import axios from 'axios'
import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import Preloader from '../../components/Preloader/Preloader'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'
import i18next from 'i18next'
import { FaSpinner } from 'react-icons/fa'

type Props = {}

const ResetPassword = (props: Props) => {
    const navigate = useNavigate()
    const [email, setEmail] = useState("")
    const [showResetPassword, setShowResetPassword] = useState(false)
    const [loading, setLoading] = useState(false)
    const [password, setPassword] = useState("")
    const [confirmPassword, setConfirmPassword] = useState("")
    const [otp, setOtp] = useState("")
    const { t } = useTranslation()
    const [timeLeft, setTimeLeft] = useState(0)

    // Function to start the timer and store timestamp
    const startTimer = () => {
        const now = Date.now()
        const expireTime = now + 60 * 1000 // 1-minute expiry
        localStorage.setItem("otp_timer", expireTime.toString())
        setTimeLeft(60)
    }

    // Effect to check the timer on mount
    useEffect(() => {
        const storedExpireTime = localStorage.getItem("otp_timer")
        if (storedExpireTime) {
            const remainingTime = Math.floor((parseInt(storedExpireTime) - Date.now()) / 1000)
            if (remainingTime > 0) {
                setTimeLeft(remainingTime)
            }
        }

        // Timer countdown
        const interval = setInterval(() => {
            setTimeLeft((prev) => {
                if (prev <= 1) {
                    clearInterval(interval)
                    localStorage.removeItem("otp_timer")
                    return 0
                }
                return prev - 1
            });
        }, 1000)

        return () => clearInterval(interval)
    }, [])

    
    const generateOtp = async () => {
        if (email.trim() === "") return toast.error(t('register.email_required'))

        setLoading(true)
        axios.post(`${process.env.REACT_APP_API_BASE_URL}/user/generate-otp`, {
            "email": email,
            "reset_password": true,
        }).then( res => {
            setLoading(false)
            console.log("res", res)
            if (res.status == 200) {
                setShowResetPassword(true)
            }
            startTimer() // Start timer after OTP request
        }).catch( err => {
            setLoading(false)
            console.log("err", err.response)
            
            if (err.response && err.response.data ) {
                for (let msgKey in err.response.data) {
                    toast.error(err.response.data[msgKey][0])
                }
            } else {
                toast.error(t('reset_password.error_sending_otp'))
            }
        })
    }

    const resetPassword = async () => {
        if (email.trim() === "" || otp.trim() === "") return toast.error(t('register.email_otp_required'))

        setLoading(true)
        axios.post(`${process.env.REACT_APP_API_BASE_URL}/user/reset-password`, {
            "email": email.trim(),
            "otp": otp.trim() ,
            "new_password": password,
            "confirm_new_password": confirmPassword,
        }).then( res => {
            setLoading(false)
            console.log("res", res)
            toast.success("Password reset succesfully")
            navigate("/login")

        }).catch( err => {
            setLoading(false)
            console.log("err", err.response)
            toast.error(err.response.data ? err.response.data.error : "Error Resetting")
        })
    }

    return (
        <>
        {loading && (<Preloader/>)}
        <div style={{paddingTop:"2rem", paddingRight: "2rem", paddingLeft:"2rem", paddingBottom:"3rem", height:"100vh"}}>
            <div className="auth-page-header mb-3">
                <div className="container">
                <div className="row">
                    <div className="col-12">
                    <h3 className="auth-page-header__title">{t('reset_password.reset_password')}</h3>
                    </div>
                </div>
                </div>
            </div>

            <div className="auth-page-body">
                <div className="container">
                <div className="row">
                    <div className="col-12">
                    <div className="px-2 py-4 rounded-3xl">
                        <form>
                            <div className="auth-form__single-field space-mb--30">
                                <label>{t('reset_password.email')}</label>
                                <input value={email} onChange={(e)=>{setEmail(e.target.value)}} type="text" placeholder={t('reset_password.enter_email')}/>
                            </div>
                            {showResetPassword && (
                                <>
                                <div className="auth-form__single-field space-mb--30">
                                    <label>{t('reset_password.otp')}</label>
                                    <input value={otp} onChange={(e)=>{setOtp(e.target.value)}} type="text" placeholder={t('reset_password.enter_otp')} />
                                </div>
                                <div className="auth-form__single-field space-mb--30">
                                    <label>{t('reset_password.password')}</label>
                                    <input value={password} onChange={(e)=>{setPassword(e.target.value)}} type="text" placeholder={t('reset_password.enter_password')} />
                                </div>
                                <div className="auth-form__single-field space-mb--30">
                                    <label>{t('reset_password.confirm_password')}</label>
                                    <input value={confirmPassword} onChange={(e)=>{setConfirmPassword(e.target.value)}} type="text" placeholder={t('reset_password.confirm_password')}/>
                                </div>
                                </>
                            )}

                            <div className="auth-form__single-field space-mb--30">
                                <p className="auth-form__info-text">
                                {t('reset_password.login')}{" "}
                                <Link to={"/login"}>{t('reset_password.sign_in')}</Link>
                                </p>
                            </div>
                            <button type="button" onClick={showResetPassword ? resetPassword : generateOtp} disabled={(!showResetPassword && loading) || (!showResetPassword && timeLeft > 0)} className="text-white text-[16px] leading-none w-full py-[15px] bg-theme border-none rounded-3xl flex items-center justify-center disabled:bg-gray-300">
                                {loading ? (
                                    <FaSpinner className="animate-spin" />
                                ) : (
                                    showResetPassword ? t('reset_password.reset') : timeLeft > 0 ? `Resend OTP (${timeLeft}s)` : t("reset_password.send_otp")
                                )}
                            </button>

                            <div className="row w-3/6 my-4 px-2 float-right">
                                <select className="px-2 py-1 border rounded-full text-md bg-white focus:outline-none focus:ring-2 focus:ring-theme appearance-none" onChange={(e) => { i18next.changeLanguage(e.target.value) }}>
                                    <option value="-1" selected disabled>-- Language --</option>
                                    <option value="en">English</option>
                                    <option value="zh">Mandarin</option>
                                    <option value="ms">Bahasa</option>
                                </select>
                            </div>
                        </form>
                    </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
        </>
 
    )
}

export default ResetPassword